import { useState } from "react";
import "./installGuide.css";
import android1 from "../../assets/img/webApp-guide/android-step-1.png";
import android2 from "../../assets/img/webApp-guide/android-step-2.png";
import android3 from "../../assets/img/webApp-guide/android-step-3.png";
import desktop1 from "../../assets/img/webApp-guide/desktop-step-1.png";
import desktop2 from "../../assets/img/webApp-guide/desktop-step-2.png";
import ios1 from "../../assets/img/webApp-guide/ios-step-1.png";
import ios2 from "../../assets/img/webApp-guide/ios-step-2.png";
import ios3 from "../../assets/img/webApp-guide/ios-step-3.png";

const InstallGuide = () => {
  const [guide, setGuide] = useState("iphone");

  return (
    <div className="container install-guide p-1 p-sm-5 d-flex flex-column align-items-center gap-5">
      <h1 className="fs-3 fw-bold m-auto d-flex justify-content-center">
        راهنمای نصب وب اپلیکیشین
      </h1>

      <div className="btn-container">
        <button
          className={guide === "iphone" ? "active" : ""}
          onClick={() => setGuide("iphone")}
        >
          آیفون / Safari
        </button>
        <button
          className={guide === "android" ? "active" : ""}
          onClick={() => setGuide("android")}
        >
          اندروید / Chrome
        </button>
        <button
          className={guide === "desktop" ? "active" : ""}
          onClick={() => setGuide("desktop")}
        >
          ویندوز / Chrome
        </button>
      </div>

      <div className="guide-desc p-3">
        {guide === "iphone" && (
          <div className="iphone-guide">
            <div className="guide-step">
              <p>
                <span>1 :</span>در منوی مرورگر {"(نوار پایین صفحه)"} گزینه نشان شده در عکس را انتخاب کنید.
              </p>
              <img src={ios1}alt="عکس راهنما" />
            </div>
            <div className="guide-step">
              <p>
                <span>2 :</span>در منوی باز شده گزینه Add To Home Screen را لمس کنید.
              </p>
              <img src={ios2} alt="عکس راهنما" />
            </div>
            <div className="guide-step">
              <p>
                <span>3 :</span>نهایتا دکمه Add را لمس کنید . اکنون آتروپین در کنار دیگر اپلیکیشین های شماست.
              </p>
              <img src={ios3} alt="عکس راهنما" />
            </div>
          </div>
        )}
        {guide === "android" && (
          <div className="android-guide">
            <div className="guide-step">
              <p>
                <span>1 :</span>ابتدا آیکون سه نقطه ای که در بالا سمت راست
                مرورگر وجود دارد را لمس کنید.
              </p>
              <img src={android1} alt="عکس راهنما" />
            </div>
            <div className="guide-step">
              <p>
                <span>2 :</span>در منوی باز شده گزینه Add To Home Screen را پیدا
                کرده و انتخاب کنید.
              </p>
              <img src={android2} alt="عکس راهنما" />
            </div>
            <div className="guide-step">
              <p>
                <span>3 :</span>نهایتا گزینه install را لمس کنید . اکنون آتروپین
                در کنار دیگر اپلیکیشین های شماست.
              </p>
              <img src={android3} alt="عکس راهنما" />
            </div>
          </div>
        )}
        {guide === "desktop" && (
          <div className="desktop-guide">
            <div className="guide-step">
              <p>
                <span>1 :</span>
                ابتدا بر روی آیکون مانیتور که در کنار آیکون ستاره قرار دارد کلیک کنید.
              </p>
              <img src={desktop1} alt="عکس راهنما" />
            </div>
            <div className="guide-step">
              <p>
                <span>2 :</span>
                در پاپ آپ باز شده بر روی install کلیک کنید. اکنون آتروپین در کنار دیگر اپلیکیشین های شماست.
              </p>
              <img src={desktop2} alt="عکس راهنما" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstallGuide;
